/**
 * Recruitment Module: Search interactions & Online CV upload modal
 *
 * @package Gina_Theme
 */
(function() {
  'use strict';

  function initRecruitment() {
    const isArchive = document.querySelector('.recruitment-archive-page');
    const isSingle = document.querySelector('.recruitment-single-page');
    if (!isArchive && !isSingle) return;

    // 1. Search Bar Keyword Clear Button
    const keywordInput = document.getElementById('recruitment-keyword-input');
    const clearKeywordBtn = document.getElementById('clear-keyword-btn');
    if (keywordInput && clearKeywordBtn) {
      keywordInput.addEventListener('input', function() {
        clearKeywordBtn.classList.toggle('hidden', keywordInput.value.trim() === '');
      });
      clearKeywordBtn.addEventListener('click', function() {
        keywordInput.value = '';
        clearKeywordBtn.classList.add('hidden');
        keywordInput.focus();
      });
    }

    // 2. Online CV Upload Modal
    const applyModal = document.getElementById('recruitment-apply-modal');
    const closeApplyBtn = document.getElementById('btn-close-apply-modal');
    const applyForm = document.getElementById('recruitment-apply-form');
    const modalJobTitle = document.getElementById('modal-job-title');
    const modalJobIdInput = document.getElementById('modal-input-job-id');
    const modalJobTitleInput = document.getElementById('modal-input-job-title');
    const applyAlert = document.getElementById('apply-modal-alert');

    const fileInput = document.getElementById('cv-file-input');
    const filePlaceholder = document.getElementById('cv-upload-placeholder');
    const fileSelectedInfo = document.getElementById('cv-selected-info');
    const fileNameDisplay = document.getElementById('cv-file-name');
    const removeCvBtn = document.getElementById('btn-remove-cv');

    const submitBtn = document.getElementById('btn-submit-cv-apply');
    const submitText = document.getElementById('btn-submit-text');
    const submitIcon = document.getElementById('btn-submit-icon');
    const submitSpinner = document.getElementById('btn-submit-spinner');

    function openApplyModal(jobId, jobTitle) {
      if (!applyModal) return;
      if (modalJobTitle) modalJobTitle.textContent = jobTitle || 'Vị trí tuyển dụng';
      if (modalJobIdInput) modalJobIdInput.value = jobId || '0';
      if (modalJobTitleInput) modalJobTitleInput.value = jobTitle || '';

      if (applyAlert) {
        applyAlert.className = 'hidden';
        applyAlert.textContent = '';
      }

      applyModal.classList.add('active');
      document.body.style.overflow = 'hidden';

      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        window.lucide.createIcons();
      }
    }

    function closeApplyModal() {
      if (!applyModal) return;
      applyModal.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Bind Open Buttons
    document.addEventListener('click', function(e) {
      const applyTrigger = e.target.closest('.btn-open-apply-modal');
      if (applyTrigger) {
        e.preventDefault();
        const jobId = applyTrigger.dataset.jobId || '0';
        const jobTitle = applyTrigger.dataset.jobTitle || '';
        openApplyModal(jobId, jobTitle);
      }
    });

    if (closeApplyBtn) {
      closeApplyBtn.addEventListener('click', closeApplyModal);
    }

    if (applyModal) {
      applyModal.addEventListener('click', function(e) {
        if (e.target === applyModal) closeApplyModal();
      });
    }

    // File Upload Handlers
    if (fileInput) {
      fileInput.addEventListener('change', function() {
        if (fileInput.files && fileInput.files[0]) {
          const file = fileInput.files[0];
          if (fileNameDisplay) fileNameDisplay.textContent = file.name;
          if (filePlaceholder) filePlaceholder.classList.add('hidden');
          if (fileSelectedInfo) fileSelectedInfo.classList.remove('hidden');
          if (window.lucide && typeof window.lucide.createIcons === 'function') {
            window.lucide.createIcons();
          }
        }
      });
    }

    if (removeCvBtn && fileInput) {
      removeCvBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        fileInput.value = '';
        if (filePlaceholder) filePlaceholder.classList.remove('hidden');
        if (fileSelectedInfo) fileSelectedInfo.classList.add('hidden');
      });
    }

    // AJAX Apply Form Submission
    if (applyForm) {
      applyForm.addEventListener('submit', async function(e) {
        e.preventDefault();

        if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
          if (applyAlert) {
            applyAlert.className = 'p-3.5 rounded-xl text-xs font-semibold bg-red-50 text-red-600 border border-red-200 block';
            applyAlert.textContent = 'Vui lòng đính kèm file CV của bạn.';
          }
          return;
        }

        const formData = new FormData(applyForm);

        // Loading state
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Đang gửi hồ sơ...';
        if (submitIcon) submitIcon.classList.add('hidden');
        if (submitSpinner) submitSpinner.classList.remove('hidden');
        if (applyAlert) applyAlert.className = 'hidden';

        try {
          const ajaxUrl = (window.ginaData && window.ginaData.ajaxUrl) ? window.ginaData.ajaxUrl : '/wp-admin/admin-ajax.php';
          const response = await fetch(ajaxUrl, {
            method: 'POST',
            body: formData,
          });

          const res = await response.json();

          if (res.success) {
            if (applyAlert) {
              applyAlert.className = 'p-3.5 rounded-xl text-xs font-semibold bg-primary-10 text-dark border border-primary/30 block';
              applyAlert.textContent = (res.data && res.data.message) ? res.data.message : 'Nộp hồ sơ ứng tuyển thành công! Nhà tuyển dụng sẽ sớm liên hệ với bạn.';
            }
            applyForm.reset();
            if (filePlaceholder) filePlaceholder.classList.remove('hidden');
            if (fileSelectedInfo) fileSelectedInfo.classList.add('hidden');

            setTimeout(function() {
              closeApplyModal();
            }, 2500);
          } else {
            if (applyAlert) {
              applyAlert.className = 'p-3.5 rounded-xl text-xs font-semibold bg-red-50 text-red-600 border border-red-200 block';
              applyAlert.textContent = (res.data && res.data.message) ? res.data.message : 'Có lỗi xảy ra khi nộp hồ sơ. Vui lòng kiểm tra lại.';
            }
          }
        } catch (err) {
          console.error('Apply CV error:', err);
          if (applyAlert) {
            applyAlert.className = 'p-3.5 rounded-xl text-xs font-semibold bg-red-50 text-red-600 border border-red-200 block';
            applyAlert.textContent = 'Mất kết nối máy chủ. Vui lòng thử lại sau.';
          }
        } finally {
          if (submitBtn) submitBtn.disabled = false;
          if (submitText) submitText.textContent = 'Nộp hồ sơ ứng tuyển';
          if (submitIcon) submitIcon.classList.remove('hidden');
          if (submitSpinner) submitSpinner.classList.add('hidden');
          if (window.lucide && typeof window.lucide.createIcons === 'function') {
            window.lucide.createIcons();
          }
        }
      });
    }

    // Global Escape Key to close apply modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeApplyModal();
      }
    });
  }

  window.GinaRecruitment = { init: initRecruitment };
})();
